// if the array is divisible by 3, then we just split the array into chunks of 3 items each
// otherwise, we split the array into chunks of 4 and the last row would have the remaining items
export const getRowSize = (keyPointsLength: number) => {
  if (keyPointsLength % 3 === 0) {
    return 3;
  } else {
    return 4;
  }
};

const organizeArray = <T>(array: T[], rowSize: number) => {
  const result: T[][] = [];
  for (let i = 0; i < array.length; i += rowSize) {
    result.push(array.slice(i, i + rowSize));
  }

  return result;
};

// To prevent a single item from being on a row on its own, if the chunk size is 4 and the array is odd,
// then we just take 3 items so it becomes even.
export const arrangeByRows = <T>(inputArray: T[], rowSize: number) => {
  const array = [...inputArray];
  const oddElements =
    rowSize === 4 && array.length % 2 === 1 ? [array.splice(0, 3)] : [];
  const organizedArray = [...oddElements, ...organizeArray(array, rowSize)];
  organizedArray.sort((a, b) => b.length - a.length);
  return organizedArray;
};
